import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import { Toaster } from "@/components/ui/use-toast";
import ScrollToTop from "./components/ScrollToTop";
import { initPreload } from './utils/preloadData';

// Lazy load non-critical pages for better initial load performance
const SearchPromo = lazy(() => import('./pages/SearchPromo'));
const PromoDetails = lazy(() => import('./pages/PromoDetails'));
const PromoList = lazy(() => import('./pages/PromoList'));
const PromoDetailPage = lazy(() => import('./pages/PromoDetailPage'));
const AddPromo = lazy(() => import('./pages/AddPromo'));
const ProvinceDetails = lazy(() => import('./pages/ProvinceDetails'));
const NotFound = lazy(() => import('./pages/NotFound'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const FAQ = lazy(() => import('./pages/FAQ'));
const OmaggiConcorsi = lazy(() => import('./pages/OmaggiConcorsi'));
const ConcorsiAcquisto = lazy(() => import('./pages/ConcorsiAcquisto'));
const Omaggi = lazy(() => import('./pages/Omaggi'));
const Tester = lazy(() => import('./pages/Tester'));
const ConcorsiGratuiti = lazy(() => import('./pages/ConcorsiGratuiti'));

// Minimal loading fallback for fast perceived performance
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      <span className="text-sm text-muted-foreground">Caricamento...</span>
    </div>
  </div>
);

function App() {
  useEffect(() => {
    // Preload common data in background
    initPreload();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchPromo />} />
          <Route path="/promo/:id" element={<PromoDetails />} />
          <Route path="/promo-list" element={<PromoList />} />
          <Route path="/promo-detail/:id" element={<PromoDetailPage />} />
          <Route path="/add" element={<AddPromo />} />
          <Route path="/add/:promoId" element={<AddPromo />} />
          <Route path="/add/:promoId/:provinceId" element={<AddPromo />} />
          <Route path="/promo/:promoId/province/:provinceId" element={<ProvinceDetails />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/omaggi-concorsi" element={<OmaggiConcorsi />} />
          <Route path="/concorsi-acquisto" element={<ConcorsiAcquisto />} />
          <Route path="/omaggi-concorsi/omaggi" element={<Omaggi />} />
          <Route path="/omaggi-concorsi/tester" element={<Tester />} />
          <Route path="/omaggi-concorsi/concorsi-gratuiti" element={<ConcorsiGratuiti />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Toaster />
    </Router>
  );
}

export default App;
